import { request } from "@umijs/max";

/**
 * 订单类型
 */
export enum OrderTypeEnum {
  // 新购
  NEWLY_PURCHASED = "FIRST",
  // 续费
  RENEW = "RENEW",
  // 升级为正式版，算成新购
  UPGRADE = "UPGRADE",
  /** 升级模板 */
  UPGRADE_TEMPLATE = "UPGRADE_TEMPLATE",
  /** 订阅版本 */
  MEMBER = "MEMBER",
  /** 续费订阅 */
  RENEW_MEMBER = "RENEW_MEMBER",
  /** 升级订阅 */
  UPGRADE_MEMBER = "UPGRADE_MEMBER",
  /** 自动续费 */
  AUTO_RENEW_MEMBER = "AUTO_RENEW_MEMBER",
}

export const OrderTypes = {
  [OrderTypeEnum.NEWLY_PURCHASED]:
    "pages.resource.order.table.consumption-type.order-type.newly-purchased",
  [OrderTypeEnum.RENEW]:
    "pages.resource.order.table.consumption-type.order-type.renew",
  [OrderTypeEnum.UPGRADE]:
    "pages.resource.order.table.consumption-type.order-type.upgrade",
  [OrderTypeEnum.UPGRADE_TEMPLATE]:
    "pages.resource.order.table.consumption-type.order-type.upgrade-template",
  [OrderTypeEnum.MEMBER]:
    "pages.resource.order.table.consumption-type.order-type.member",
  [OrderTypeEnum.RENEW_MEMBER]:
    "pages.resource.order.table.consumption-type.order-type.renew-member",
  [OrderTypeEnum.UPGRADE_MEMBER]:
    "pages.resource.order.table.consumption-type.order-type.upgrade-member",
  [OrderTypeEnum.AUTO_RENEW_MEMBER]:
    "pages.resource.order.table.consumption-type.order-type.auto-renew-member",
};

/**
 * 订单状态
 */
export enum OrderStatusEnum {
  // 待支付
  PENDING = "WAIT_PAY",
  // 已支付
  PAID = "DONE",
  // 作废
  CANCELLED = "CANCEL",
}

export const OrderStatus = {
  [OrderStatusEnum.PENDING]:
    "pages.resource.order.detail.subtitle.information.order-status.pending",
  [OrderStatusEnum.PAID]:
    "pages.resource.order.detail.subtitle.information.order-status.paid",
  [OrderStatusEnum.CANCELLED]:
    "pages.resource.order.detail.subtitle.information.order-status.cancelled",
};

export const OrderStatusClassName = {
  /** 作废 */
  [OrderStatusEnum.CANCELLED]:
    "bg-gray-1 text-gray-6 border-[1px] rounded-[4px] !border-gray-3",
  /** 待支付 */
  [OrderStatusEnum.PENDING]:
    "bg-red-1 text-red-6 border-[1px] rounded-[4px] !border-red-3",
  /** 已支付 */
  [OrderStatusEnum.PAID]:
    "bg-green-1 text-green-6 border-[1px] rounded-[4px] !border-green-3",
};

/**
 * 财务审批状态
 */
export enum FinanceApprovalStatusEnum {
  // 待审批
  PENDING = "WAIT",
  // 审批通过
  APPROVED = "PASS",
}

export const FinanceApprovalStatus = {
  [FinanceApprovalStatusEnum.PENDING]: "待审批",
  [FinanceApprovalStatusEnum.APPROVED]: "审批通过",
};

interface IOrdersListData {
  pageNum: number;
  pageSize: number;
  startTime: string;
  endTime: string;
  orderId: string;
  tenantId: string;
}

interface IPagnation<T> {
  current: number;
  pages: number;
  size: number;
  total: number;
  records: T[];
}

/**
 * 获取订单列表
 */
export const postOrdersList = (data: Partial<IOrdersListData>) => {
  return request<
    API.BaseResponse<
      IPagnation<{
        approvalStatus: `${FinanceApprovalStatusEnum}`;
        approvalTime: string;
        appoverName: string;
        consumptionType: `${OrderTypeEnum}`;
        createTime: string;
        goodsName: string;
        orderId: string;
        orderStatus: `${OrderStatusEnum}`;
        payAmount: number;
        payTime: string;
        tenantId: string;
        userName: string;
      }>
    >
  >(`/api/damselfish-fee-center/userSearch/orderPage`, {
    method: "POST",
    data,
  });
};

/**
 * 导出订单列表 url
 * @param data
 * @returns
 */
export const getExportOrdersListUrl = (data: Partial<IOrdersListData>) => {
  const queryStr = Object.entries(data)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");

  return `/api/damselfish-fee-center/userSearch/orderPage/export?${queryStr}`;
};

export interface IOrderInfoDetail {
  userName: string;
  payTime: string;
  payId: string;
  orderStatus: `${OrderStatusEnum}`;
  orderId: string;
  createTime: string;
  consumptionType: `${OrderTypeEnum}`;
  approvalStatus: `${FinanceApprovalStatusEnum}`;
  amount: number;
  orderDetailRespList: {
    goodsName: string;
    nums: number;
    payAmount: number;
    totalAmount: number;
    discountAmount: number;
  }[];
}

/**
 * 获取订单详情
 * @param {string} orderId
 */
export const getOrderInfoDetail = (orderId: string) => {
  return request<API.BaseResponse<IOrderInfoDetail>>(
    `/api/damselfish-fee-center/userSearch/orderInfo?orderId=${orderId}`
  );
};
